import StorageHelper from 'Stores/helper';

const scope = 'CAMPAIGNS/legislators';

const defaultState = {
    activeCallLegislatorId: null,
    apiLegislatorResults: {},
    callsCompleted: false,
    callInProgress: false,
    errorMessage: null,
    expandedLegislatorLists: [],
    legislatorResults: {},
    initialLegislatorResults: {},
    legislatorsPulled: false,
    legislatorsCalled: {},
    loading: false,
    nextCallLegislatorId: null,
    pusherInstantiated: false,
    twitterCharactersRemaining: {},
    emailMessageModified: false,
    fetchLegislatorsAddressPayload: {},
    showOneStepClosing: false,
    tweetsPosted: []
};

const mod = {
    namespaced: true,
    state: {
        activeCallLegislatorId: null,
        apiLegislatorResults: {},
        callsCompleted: false,
        callInProgress: false,
        currentMessage: 0,
        errorMessage: null,
        expandedLegislatorLists: [],
        legislatorResults: {},
        legislatorsPulled: false,
        legislatorsCalled: {},
        loading: false,
        nextCallLegislatorId: null,
        pusherInstantiated: false,
        twitterCharactersRemaining: {},
        emailMessageModified: false,
        fetchLegislatorsAddressPayload: {},
        showOneStepClosing: false,
        tweetsPosted: []
    },
    mutations: {
        activeCallLegislatorId: (state, id) => {
            state.activeCallLegislatorId = id
        },
        apiLegislatorResults: (state, legResultsObject) => {
            state.apiLegislatorResults = legResultsObject
        },
        callsCompleted: (state, bool) => {
          state.callsCompleted = bool;
        },
        callInProgress: (state, bool) => {
          state.callInProgress = bool;
        },
        currentMessage(state, index) {
          state.currentMessage = index;
        },
        errorMessage: (state, message) => {
          state.errorMessage = message;
        },
        expandedLegislatorLists: (state, legislatorListArray) => {
            state.expandedLegislatorLists = legislatorListArray
        },
        initialLegislatorResults: (state, object) => {
            state.initialLegislatorResults = object;
            state.legislatorResults = object;
        },
        fetchLegislatorsAddressPayload: (state, addressPayload) => {
          state.fetchLegislatorsAddressPayload = addressPayload
        },
        legislatorResults: (state, object) => {
          state.legislatorResults = object;
        },
        legislatorsCalled: (state, legsCalledObject) => {
            state.legislatorsCalled = { ...state.legislatorsCalled, ...legsCalledObject };
        },
        legislatorsPulled: (state, bool) => {
            state.legislatorsPulled = bool;
        },
        loading: (state, bool) => {
            state.loading = bool
        },
        nextCallLegislatorId: (state, id) => {
            state.nextCallLegislatorId = id
        },
        pusherInstantiated: (state, bool) => {
            state.pusherInstantiated = bool;
        },
        resetLegislatorResults: (state) => {
            state.legislatorResults = state.initialLegislatorResults;
        },
        twitterCharactersRemaining: (state, twitterCharObject) => {
            state.twitterCharactersRemaining = { ...state.twitterCharactersRemaining, ...twitterCharObject }
        },
        emailMessageModified: (state, bool) => {
          state.emailMessageModified = bool;
        },
        showOneStepClosing: (state, bool) => {
            state.showOneStepClosing = bool;
        },
        tweetsPosted: (state, tweetsPosted) => {
            state.tweetsPosted = tweetsPosted;
        }
    },
    actions: {
        activeCallLegislatorId({commit}, id) {
            commit("activeCallLegislatorId", id)
        },
        apiLegislatorResults({commit}, legResultsObject) {
            commit("apiLegislatorResults", legResultsObject)
        },
        callsCompleted({ commit }, bool) {
            StorageHelper.setLocalStorageVar(commit, bool, 'callsCompleted', scope);
        },
        callInProgress({ commit }, bool) {
            StorageHelper.setLocalStorageVar(commit, bool, 'callInProgress', scope);
        },
        currentMessage({ commit }, index) {
          commit("currentMessage", index);
        },
        errorMessage({ commit }, message) {
          StorageHelper.setLocalStorageVar(commit, message, 'errorMessage', scope);
        },
        expandedLegislatorLists({ commit }, legislatorListArray) {
            StorageHelper.setLocalStorageVar(commit, legislatorListArray, 'expandedLegislatorLists', scope);
        },
        fetchLegislatorsAddressPayload({ commit }, addressPayload) {
          StorageHelper.setLocalStorageVar(commit, addressPayload, 'fetchLegislatorsAddressPayload', scope);
        },
        initialLegislatorResults({ commit }, legislatorObject) {
          StorageHelper.setLocalStorageVar(commit, legislatorObject, 'initialLegislatorResults', scope);
        },
        legislatorResults({ commit }, legislatorObject) {
            StorageHelper.setLocalStorageVar(commit, legislatorObject, 'legislatorResults', scope);
        },
        legislatorsCalled({ commit }, legsCalledObject) {
            StorageHelper.setLocalStorageVar(commit, legsCalledObject, 'legislatorsCalled', scope);
        },
        legislatorsPulled({ commit }, bool) {
            StorageHelper.setLocalStorageVar(commit, bool, 'legislatorsPulled', scope);
        },
        loading({ commit }, bool) {
            commit('loading', bool);
        },
        nextCallLegislatorId({commit}, id) {
            commit("nextCallLegislatorId", id)
        },
        pusherInstantiated ({ commit }, bool) {
            StorageHelper.setLocalStorageVar(commit, bool, 'pusherInstantiated', scope);
        },
        resetLegislatorResults({ commit }) {
            commit("resetLegislatorResults");
        },
        twitterCharactersRemaining ({ commit }, twitterCharObject) {
            commit("twitterCharactersRemaining", twitterCharObject);
        },
        emailMessageModified ({commit}, bool) {
            commit('emailMessageModified', bool);
        },
        showOneStepClosing ({commit}, bool) {
            commit('showOneStepClosing', bool);
        },
        tweetsPosted({ commit }, tweetsPosted) {
            commit("tweetsPosted", tweetsPosted);
        }
    },
    getters: {
        activeCallLegislatorId(state) {
            return state.activeCallLegislatorId;
        },
        apiLegislatorResults(state) {
            return state.apiLegislatorResults;
        },
        callsCompleted(state) {
            return state.callsCompleted;
        },
        callInProgress(state) {
            return state.callInProgress;
        },
        currentMessage({ currentMessage }) {
          return currentMessage;
        },
        errorMessage(state) {
          return state.errorMessage;
        },
        expandedLegislatorLists(state) {
            return state.expandedLegislatorLists;
        },
        fetchLegislatorsAddressPayload(state) {
            return state.fetchLegislatorsAddressPayload;
        },
        legislatorResults(state) {
            return state.legislatorResults;
        },
        legislatorsCalled(state) {
            return state.legislatorsCalled;
        },
        legislatorsPulled(state) {
            return state.legislatorsPulled;
        },
        loading(state) {
            return state.loading;
        },
        nextCallLegislatorId(state) {
          return state.nextCallLegislatorId;
        },
        pusherInstantiated(state) {
            return state.pusherInstantiated;
        },
        twitterCharactersRemaining(state) {
            return state.twitterCharactersRemaining;
        },
        emailMessageModified(state) {
            return state.emailMessageModified;
        },
        showOneStepClosing(state) {
            return state.showOneStepClosing;
        },
        tweetsPosted(state) {
            return state.tweetsPosted;
        }
    },
};

export default mod;
